<i id="{{id}}" class="fas" [ngClass]="icon" aria-hidden="true"></i>
